import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { hookFormZod } from '@ipfabric/ui-components/utils/hookForm/hookFormZod';
import { retryDefault } from '@ipfabric/utils';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export type BasicFailureFieldValues = { cliRetryBasicFailure: string };
export type BasicFailureOutputValues = { cliRetryBasicFailure: number };

export const basicFailure: FormSnippet<
  DiscoverySettingsObject,
  BasicFailureFieldValues,
  BasicFailureOutputValues
> = {
  render: ({ form }) => (
    <FormTextField
      control={form.control}
      type='number'
      name='cliRetryBasicFailure'
      description='Number of retries after any connection error, except authentication failure.'
      label='Basic failure'
      endAdornment='retries'
      inputWidthClassName='w-60'
    />
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.cliRetryBasicFailure =
      model.cliRetryLimit?.default?.toString() ?? '';
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.cliRetryLimit ??= {};
    modelDraft.cliRetryLimit.default = transformedValues.cliRetryBasicFailure;
  },
  schema: z.object({
    cliRetryBasicFailure: hookFormZod.numberInputWith(
      hookFormZod.minMax(retryDefault.min, retryDefault.max),
    ),
  }),
};
